<template>
  <div
    class="home1 full-height"
    style="background: #fff"
  >
    <!-- default-banner linear-main3  -->
    <div class="bg-khmain">
      <van-swipe
        :autoplay="5000"
        height="75"
      >
        <van-swipe-item
          v-for="(advertise, index_) in images"
          :key="index_"
        >
          <van-image
            lazy-load
            :src="advertise.pictureUrl"
            @click="goAdvertiseLink(advertise.advertiseLink)"
            class="full-width"
          />
        </van-swipe-item>
      </van-swipe>
      <ld-statusbar />

      <!--      康辉头-->
      <div class="bg-khto">
        <div class="tx">
          <img src="./images/home/tox.png">
        </div>

        <div class="bg-khto1">
          <span class="bg-khto1-nm">{{
            userInfo.empInfo && userInfo.empInfo.empName
          }}</span>
          <br>
          <span class="bg-khto1-company">{{ userInfo.vipCorp && userInfo.vipCorp.fullname }}&nbsp;</span>
        </div>
        <div>
          <div
            class="server text-center pointerEvents"
            @click="$router.push({ path: '/service' })"
          >
            <div class="font12">
              <!-- <i class="iconfont" style="color: #fff;font-size: 22px">
                &#xe680;
              </i> -->
              <img src="./images/home/kf.png" alt="" class="kf">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="full-width"
      style="position: absolute;padding: 0px 10px 0 10px;;pointer-events: none;"
    >
      <div class="defaulthomewrapper">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <!-- pointerEvents:auto :处理banner图覆盖问题 -->
          <div class="pointerEvents">
            <!-- Menu -->
            <div
              class="list round-md"
              style="margin: 10px 0 4px 0px;"
            >
              <van-cell
                class="round-md bg-image"
                v-show="orderList.length == 0"
                style="height: 110px"
                center
              >
                <div style="padding: 10px">
                  <div class="font20 font-bold green">
                    暂无行程
                  </div>
                  <div class="gray">
                    暂无日程，前往预订
                  </div>
                </div>
                <div slot="right-icon">
                  <img
                    src="~Components/Dynamic/default/images/schedule-empty.png"
                    style="width: 136px; margin-top: 29px"
                  >
                </div>
              </van-cell>
              <van-swipe
                class="shadow vanSwipe"
                :autoplay="4000"
                height="110"
                v-show="orderList.length"
              >
                <van-swipe-item
                  v-for="(item, index) in orderList"
                  :key="index"
                  @click="$router.push({ path: '/schedule' })"
                >
                  <SchedulePanel
                    :data="item"
                    :order-type="item.orderType"
                  />
                </van-swipe-item>
              </van-swipe>
            </div>

            <!--  -->
            <div
              class="list"
              v-if="loginNotices && loginNotices.length"
            >
              <van-notice-bar
                class="full-width round-md shadow"
                background="#ffffff"
                mode="link"
                color="#707070"
                @click="$router.push({ path: '/noticeList' })"
              >
                <van-image
                  width="24"
                  style="padding-right: 6px"
                  slot="left-icon"
                  :src="bullhorn_icon"
                />
                <span
                  v-for="notice in loginNotices"
                  :key="notice.id"
                >
                  {{ notice.content }}
                </span>
              </van-notice-bar>
            </div>

            <div class="kh-home-main">
              <!-- :class="[item.openDiasble ? 'menu-disabled' : '']" -->
              <van-row
                type="flex"
                gutter="10"
              >
                <van-col
                  span="12"
                  v-for="tab in menuList"
                  :key="tab.link"
                  class="list"
                  v-if="tab.openDiasble"
                  style="background:#efeff6;width: 171px;height: 152px;margin: 0 0 6px 0px;border-radius: 12px;"
                >
                  <div>
                    <div
                      @click="to(tab)"
                      class="kh-a"
                    >
                      <span>
                        <img
                          :src="tab.img"
                          style="border-radius: 50px;"
                        >
                      </span>
                      <div class="gray">
                        {{ tab.label }}
                      </div>
                    </div>
                    <div
                      class="font16 font-md"
                      style="text-align: center;font-size: 12px;margin-top: 30px"
                    >
                      {{ $t(tab.title) }}
                    </div>
                  </div>
                </van-col>
              </van-row>
            <!-- 出差申请单 -->
            </div>
            <!-- 脚步模块  -->
            <!-- <div class="kh-list" v-show='modular'>
              <ul class="kh-ul">
                <li v-for="(item, index) in menuList_other" :span="item.span" :key="index" @click="to(item)" v-if="item.openDiasble" style="background:#efeff6;width: 171px;height: 152px;margin: 0 0 6px 0px;border-radius: 12px;">
                  <span class="kh-di">
                    <van-image lazy-load width="30" :src="item.img" class="full-width kh-di-img" style="width:25px;height:28px "/>
                  </span>
                  <span class="kh-mk">{{item.title}}</span>
                </li>
              </ul> -->
            <!--              <van-col v-for="(item, index) in menuList_other" :span="item.span" :key="index" @click="to(item)"-->
            <!--                       v-if="item.openDiasble">-->
            <!--                <div class="khqzbf">-->
            <!--                      <span class="kh-di">-->
            <!--                          <van-image lazy-load width="30" :src="item.img" class="full-width" />-->
            <!--                      </span>-->
            <!--                </div>-->
            <!--              </van-col>-->
            <!-- </div> -->
          </div>
        </mescroll-vue>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Tabbar,
  TabbarItem,
  Popup,
  Grid,
  GridItem,
  Icon,
  NoticeBar,
  Image as VanImage,
  Cell,
  Swipe,
  SwipeItem,
} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { getTimeState } from 'Utils/dateUtil'
import ldStatusbar from 'Common/ldStatusbar'

// 康辉行程
import SchedulePanel from 'Components/Dynamic/kh/itinerary/schedule/components/panel'

//
// import menu_tk from 'Components/Dynamic/default/images/menu/tk.png'
// import menu_ht from 'Components/Dynamic/default/images/menu/ht.png'
// import menu_tr from 'Components/Dynamic/default/images/menu/tr.png'
// import menu_car from 'Components/Dynamic/default/images/menu/car.png'
// import menu_visa from 'Components/Dynamic/default/images/menu/visa.png'

import fj from 'Components/Dynamic/kh/images/home/fj.png'
import hc from 'Components/Dynamic/kh/images/home/hc.png'
import jd from 'Components/Dynamic/kh/images/home/jd.png'
import yc from 'Components/Dynamic/kh/images/home/yc.png'

import zj from 'Components/Dynamic/kh/images/home/zj.png'
import qz from 'Components/Dynamic/kh/images/home/qz.png'
import bx from 'Components/Dynamic/kh/images/home/bx.png'
import mp from 'Components/Dynamic/kh/images/home/mp.png'

//
// import menu_checkIn from 'Components/Dynamic/default/images/menu/checkIn.png'
// import menu_fastCheck from 'Components/Dynamic/default/images/menu/fastCheck.png'
// import menu_guestPass from 'Components/Dynamic/default/images/menu/guestPass.png'

import menu_strategy from 'Assets/images/home/menu_strategy.png'
import menu_discount from 'Assets/images/home/menu_discount.png'
import menu_freebus from 'Assets/images/home/menu_freebus.png'
import menu_contracthotel from 'Assets/images/home/menu_contracthotel.png'
import menu_policy from 'Assets/images/home/menu_policy.png'

import bullhorn_icon from 'Components/Dynamic/default/images/home/bullhorn.png'
import homeMixin from './homeMixin'

export default {
  name: 'Home',
  mixins: [homeMixin],
  props: {
    menulist: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [VanImage.name]: VanImage,
    [Cell.name]: Cell,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    MescrollVue,
    ldStatusbar,
    SchedulePanel,
  },
  data () {
    return {
      modular: true,
      bullhorn_icon,
      menuList: [
        {
          link: '/tk/khtkQuery',
          title: 'A008', //机票
          img: fj,
          PRO_TYPE: 10901,
          openDiasble: false
        },
        {
          link: '/ht/htQuery',
          title: 'A009', //酒店
          img: jd,
          PRO_TYPE: 10903,
          openDiasble: false

        },
        {
          link: '/tr/trQuery',
          title: 'A010', //火车票
          img: hc,
          PRO_TYPE: 10904,
          openDiasble: false

        },
        {
          link: '/car/carQuery',
          title: 'A011', //用车
          img: yc,
          PRO_TYPE: 10906,
          openDiasble: false

        },
      ],
      menuList_minor: [
        {
          link: '/tkIntel/policy',
          title: 'A019', //'国际特惠',
          img: menu_strategy,
          openDiasble: false

        },
        {
          link: '/tk/policy',
          title: 'A020', //'协议直减',
          img: menu_discount,
          openDiasble: false

        },
        {
          link: '/tk/airportBus',
          title: 'Q016', //机场大巴
          img: menu_freebus,
          openDiasble: false

        },
        {
          link: '/ht/htQuery/htSignList',
          title: 'A021', //'协议酒店',
          img: menu_contracthotel,
          openDiasble: false

        },
        {
          link: '/tk/strategy',
          title: 'Q007', //机场攻略
          img: menu_policy,
          openDiasble: false

        },
      ],
      menuList_other: [
        {
          link: '/checkIn',
          title: '在线值机',
          img: zj,
          span: 5,
          PRO_TYPE: 10916,
          openDiasble: false

        },
        {
          link: '/visa',
          title: '签证', //签证
          img:qz ,
          label: '全国受理，一对一辅导',
          span: 4,
          PRO_TYPE: 10913,
          openDiasble: false

        },
        {
          link: '',
          title: '保险',
          img: bx,
          span: 5,
          PRO_TYPE: 10917,
          openDiasble: false

        },
        {
          link: '/',
          title: '门票',
          img: mp,
          span: 5,
          PRO_TYPE: 10915,
          openDiasble: false

        },
      ],
      sqdList:{
        link: '/khtripAdd',
        title: '出差申请单 ',
        i:2
      },
      orderList: [],
      images: [],
    }
  },
  async created () {
    if (this.menulist.length) {
      this.menuList = this.menulist
    }
    await this.getAuthorizationPnos()
    this.genMenu([...this.menuList])
    this.genMenu([...this.menuList_other])
    this.init()
  },
  mounted () {
    this.getOrderList()
    this.getPullData()
  },
  methods: {
    init () {
      let newA = this.menuList_other.filter(function (item, index) { //index是索引
        return item.openDiasble == true;
      });
      console.log('newA', newA);
      if (newA != '') {
        this.modular = true
      } else {
        this.modular = false
      }
    },
    getTimeState,
    getPullData () {
      let data = {
        requestFrom: 2,
      }
      this.$api['common/pullData'](data).then((res) => {
        if (res.data) {
          const { data } = res
          let pictureUrlList = []
          data.forEach((element) => {
            let advertise = {
              pictureUrl: element.pictureUrl,
              advertiseLink: element.advertiseLink,
            }
            pictureUrlList.push(advertise)
          })
          this.images = pictureUrlList
        }
      })
    },
    goAdvertiseLink (path) {
      if (path) {
        location.href = path
      }
    },
    getOrderList () {
      this.$api['tkOrder/getScheduleOrder']()
        .then((res) => {
          var cache = res.data || {}
          this.orderList = cache.list || []
          if (this.orderList.length === 0) {
            this.getAdv()
          }
        })
        .catch(() => { })
    },
    // 获取广告图
    getAdv () { },
    // kh_List(item,index){
    //   this.$router.push(item.link)
    // }
  },
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.pointerEvents {
  pointer-events: auto;
}

.box {
  padding: 0 10px;
}

.home1 {
  //   position: relative;
  //   padding: 10px;
  //   background-size: cover;
  //   background-position-y: initial;

  .logo {
    img {
      width: 57px;
    }
  }

  .list {
    padding-bottom: 8px;
  }

  .container {
    padding: 4px;
  }

  .defaulthomewrapper {
    height: calc(100vh - 156px);
    // height: 100%;
    overflow: hidden;
  }

  .vanSwipe {
    width: calc(100vw - 20px);
  }

  .shadow {
    height: 120px;
    //box-shadow: 0 3px 3px 1px rgba(0, 0, 0, 8%);
  }
}

@{deep}.van-swipe__indicators {
  bottom: 7px;
  display: none;
}

@{deep}.van-swipe__indicator:not(.van-swipe__indicator--active) {
  border: 1px solid;
}

.default-banner {
  background-image: url("~Components/Dynamic/default/images/bg.png");
}
//康辉样式
.tx{
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 20px;
  overflow: hidden;
}
.kf{
  width: 20px;
  height: 20px;
  margin-right: 20px;
}
.bg-khto{
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  width: 100%;
}
.bg-khto1{
  color: rgb(255, 255, 255);
  font-size: 12px;
  // position: relative;
  // right: 30px;
  width: 70%;
  .bg-khto1-nm{
    font-size: 18px;
  }
  .bg-khto1-company{
    font-size: 10px;
  }
}
/deep/ .van-cell__value--alone{
  text-align: center;
}
/deep/ .bg-white{
  background: #EEEEF6;
}
.kh-a{
  position: relative;
  left: 45px;
  top: 20px;
}

.kh-di {
  display: flex;
  flex-wrap: wrap;
  width: 75px;
  height: 75px;
  display: block;
  position: relative;
  left: 45px;
  top: 20px;
  background-color: white;
  border-radius: 50%;

  .kh-di-img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.khimg{
  width: 76px;
  height: 76px;
  position: relative;
  left: -3px;
  top: -2px;
}
/deep/ .van-cell{
  padding: 5px 0px;
}
/deep/.van-row--flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

}

.khqzbf{
  width: 71px;
  height: 71px;
  background: #EEEEF6;
  border-radius:12px;
}

.kh-list{
  width: 100%;
  height: 71px;
}
.kh-ul{
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  li{
    width: 100px;
    height: 72px;
    background: #EEEEF6;
    margin: 0px 14px 0 17px;
    border-radius: 12px;
  }
}
// .kh-main{
//   height: 570px;
// }
.kh-mk{
  display: block;
  // width: 67px;
  font-size: 12px;
  text-align: center;
  // position: relative;
  // top: 20px;
  margin-top: 30px;
}
// .kh-home-sqd{
//   width: 100%;
//   height: 80px;
//   border-radius: 10px;
//   background-color: rgb(239, 239, 246);
//   display: flex;
//   .kh-home-sqd-title{
//     text-align: center;
//     margin: auto;
//     line-height: 80px;
//   }
// }
</style>
